<i18n>
{
  "en": {
    "userActive": "The user is active",
    "userNoActive": "The user is not active",
    "edit": "Edit user",
    "sendEmail": "Resend email",
    "delete": "Delete user",
    "propagate": "Propagate the data to all products assigned"
  },
  "es": {
    "userActive": "El usuario esta activo",
    "userNoActive": "El usuario no esta activo",
    "edit":  "Editar el product maestro",
    "sendEmail": "Reenviar email",
    "delete":  "Eliminar producto maestro",
    "propagate":  "Propagar los datos a todos los productos asignados"
  }
}
</i18n>
<template>
  <dynameat-row
    :title="productMaster.name"
    :description="productMaster.description"
    :button-config-list="buttonConfigList"
    :collapse-items="!$vuetify.breakpoint.mdAndUp"
    @editUserRole="onEditProductMaster"
    @deleteUserRole="onDeleteProductMaster"
    @regeneratePassUserRole="onPropagateProductMaster"
    :isClickable="false"
  >
  </dynameat-row>
</template>
<script>
import DynameatRow from '@dynameat/components/DynameatRow';
import Component from 'vue-class-component';
import { Components } from '@core/helpers/decorators';
import { Prop } from 'vue-property-decorator';
import { ProductMaster } from '@productMaster/models';
import Vue from 'vue';

@Component
@Components({ DynameatRow })
export default class ProductMasterRow extends Vue {
  @Prop({
    Object,
    validator(productMaster) {
      return productMaster instanceof ProductMaster;
    }
  }) productMaster;

  get buttonConfigList() {
    return [
      {
        title: this.$t('propagate'),
        icon: 'mdi-content-duplicate',
        emitName: 'regeneratePassUserRole',
      },
      {
        title: this.$t('edit'),
        icon: 'mdi-pencil',
        emitName: 'editUserRole',
      },
      {
        title: this.$t('delete'),
        icon: 'mdi-delete',
        emitName: 'deleteUserRole',
      }
    ];
  }

  onEditProductMaster() {
    this.$emit('edit');
  }

  onDeleteProductMaster() {
    this.$emit('delete');
  }

  onPropagateProductMaster() {
    this.$emit('propagate');
  }
}
</script>
<style>
.v-list-item__subtitle {
  white-space: normal;
}
</style>
<style scoped lang="scss">
.chip-top {
  margin-top: 0;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}
</style>
